import { PaymentData } from "../../components/datatable/paymentData";

const RfqPayment = () => {
  return <PaymentData />;
};

export default RfqPayment;
